exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product.card .content .header[data-v-492e7647], .product.card .content .description[data-v-492e7647] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.product.card .content .not-available[data-v-492e7647] {\n  color: red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-492e7647","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/merchant/AvailableProductsModal.vue
// module id = oLd6
// module chunks = 1